var _defs, _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplianceStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "btn",
    cx: 0.35,
    cy: 0.3,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86EFAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A34A"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#DCFCE7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 22,
    fill: "url(#btn)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 24a15 15 0 0 1 18-9",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.5a11 11 0 1 0 14 0",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19v13",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplianceStatus);
export default __webpack_public_path__ + "static/media/applianceStatus.26dc19d1bc1f40f074192d93d6fb135b.svg";
export { ForwardRef as ReactComponent };